import Collapse from '@mui/material/Collapse';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Modal from '@mui/material/Modal';
import Divider from '@mui/material/Divider';
import CaseDocPreviewPane from '../components/CaseDocPreviewPane';
import CaseFacts from './CaseFacts'
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { useState, useEffect} from 'react';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Badge from '@mui/material/Badge';
import Paper from '@mui/material/Paper';
import { DataGrid, GridColDef, GridToolbar, gridDateComparator } from '@mui/x-data-grid';
import DocumentContextElement from './DocumentContextElement';
import ConfirmationDialog from './ConfirmationDialog'
import CaseProgress from './CaseProgress'
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import PreviewIcon from '@mui/icons-material/Preview';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import DeleteIcon from '@mui/icons-material/Delete';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import PublishIcon from '@mui/icons-material/Publish';
import TaskIcon from '@mui/icons-material/Task';
import Alert from '@mui/material/Alert';
import RefreshIcon from '@mui/icons-material/Refresh';
import Grid from '@mui/material/Grid';
import Item from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import Container from '@mui/material/Container';
import Fab from '@mui/material/Fab';
import JSONForm from './JSONForm';
import TransformerResultDetail from './TransformerResultDetail';
import AddIcon from '@mui/icons-material/AddCircle';
import SectionHeader from './SectionHeader';
import PreprocessingResultDetail from './PreprocessingResultDetail';
import {  useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import AddFile from './AddFile'
import AddFiles from './AddFiles'
import Sidebar from '../components/Sidebar';
import CaseInfoPanel from '../components/CaseInfoPanel';
import { HOST } from '../components/config';

function CaseView() {
  const [caseInfo, setCaseInfo] = useState([]);
  const [isLoadingCaseInfo, setIsLoadingCaseInfo] = useState(true);
  const [caseFiles, setCaseFiles] = useState([]);
  const [showFacts, setShowFacts] = useState(false);
  const [isLoadingCaseFiles, setIsLoadingCaseFiles] = useState(true);
  const [isLoadingCaseDocuments, setIsLoadingCaseDocuments] = useState(true);
  
  const [processingResultModalId, setProcessingResultModalId] = useState(null); 
  
  const [currentFile, setCurrentFile] = useState({ info: {} })

  const [caseDocuments, setCaseDocuments] = useState([]);
  const [error, setError] = useState(null);
  const [pendingFileToDeleteId, setPendingFileToDeleteId] = useState(null);
  
  const [showUploadFileModal, setShowUploadFileModal] = useState(false);
  const [fileProcessingResultsInfo, setFileProcessingResultsInfo] = useState({});
  
  const [previewUrl, setPreviewUrl] = useState(null); 
  const [previewType, setPreviewType] = useState(null); 
  const [previewFileId, setPreviewFileId] = useState(null); 
  const [previewDocumentId, setPreviewDocumentId] = useState(null); 

  var previewFiles = []
  if (!isLoadingCaseDocuments) {
    caseDocuments.filter((doc) => !doc.is_context_document).sort((a,b)=> (new Date(b.updated_at)).getTime() - (new Date(a.updated_at)).getTime()).forEach((caseDoc) => {
      previewFiles.push({ created_at: caseDoc.updated_at, fileName: caseDoc.name, fileType: "pdf", type: "case_doc", documentId: caseDoc.id })
    })
    caseDocuments.filter((doc) => doc.is_context_document).sort((a,b)=> (new Date(b.updated_at)).getTime() - (new Date(a.updated_at)).getTime()).forEach((caseDoc) => {
      previewFiles.push({ created_at: caseDoc.updated_at, fileName: caseDoc.name, fileType: "json", type: "case_doc", documentId: caseDoc.id })
    })
  }
  previewFiles = previewFiles.concat(caseFiles.map((file) => { return { created_at: file.created_at, fileName: file.filename , uri: '', fileType: "pdf", type: "client_file", fileId: file.id }} ).reverse())
  useEffect( () => {
        if(!isLoadingCaseDocuments) {
          const first = previewFiles[0]
          if (!currentFile.type && first) {
            setCurrentFile({ info: {}, documentId: first.documentId, type: "case_doc" })
            reloadCaseDocumentInfo()
          }
        }

  }, [isLoadingCaseDocuments, previewFiles]);

  const { caseId } = useParams();

  const fetchCaseInfo= async () => {
    setIsLoadingCaseInfo(true);
    try {
         const response = await fetch(HOST + '/api/cases/' + caseId +'/', {
        "headers": { 
          'Authorization': 'Bearer ' + localStorage.getItem('token')
        }
      });
      const json = await response.json()
      setCaseInfo(json);
    } catch (err) {
      setError(err);
    } finally {
      setIsLoadingCaseInfo(false);
    }
  };
  
  const fetchFileProcessingResults = async (file_id) => {
      try {
        const response = await fetch(HOST + '/api/file_processing_step_results/?file_id=' + file_id, { 
          "headers": { 
            'Authorization': 'Bearer ' + localStorage.getItem('token')
          }
        });
        const json = await response.json()
        setFileProcessingResultsInfo((prevState) =>  { 
          if ((prevState[file_id] && prevState[file_id].length && json && prevState[file_id].slice(-1)[0].status == json.slice(-1)[0].status) || json.length == 0)
            return prevState
          return ({
          ...prevState,
          [file_id]: json
        })})
      } catch (err) {
        setError(err);
      }   
  }
 
  const getLastStatus = (fileId) => { 
    return fileProcessingResultsInfo[fileId] && fileProcessingResultsInfo[fileId].length ? fileProcessingResultsInfo[fileId].slice(-1)[0].status : ''
  }

  const filesAreProcessing = caseFiles.filter((file) => (getLastStatus(file.id) == 'PROCESSING')).length > 0
  const fetchCaseFiles = async () => {
    //setIsLoadingCaseFiles(true);
    try {
      const response = await fetch(HOST + '/api/files/?case_id=' + caseId, {
        "headers" : { 
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + localStorage.getItem('token')
          }
      });
      const json = await response.json()
      json.forEach((file) => fetchFileProcessingResults(file.id));
      setCaseFiles(json);
    } catch (err) {
      setError(err);
    } finally {
      setIsLoadingCaseFiles(false);
    }
  };

  const handleCaseFileUpload = async (file_info, setSuccess, setErrorMessage) => {
      var file_body = { 
        "case_id": caseId, 
        "original_file_url": file_info.file_url,
        "filename": file_info.filename,
        "type": file_info.type
      }
      fetch(HOST + '/api/files/',
      {   
        "method": "POST",
        "headers" : { 
          'Accept': 'application/json',
          'Authorization': 'Bearer ' + localStorage.getItem('token'),
          'Content-Type': 'application/json'
          },  
        "body": JSON.stringify(file_body)
       })
      .then((res) => res.json())
      .then((json) => {
        if (json.id) {
          setSuccess(true) 
          fetchCaseFiles()
        }
        else {
          setErrorMessage(json.error) 
        }
     })
  }
 
  const clearCaseDocs = () => {
    setCaseFiles([])
    setCaseDocuments([])
    setCaseInfo([])
    setIsLoadingCaseInfo(false)
    setIsLoadingCaseFiles(false)
  }

  useEffect(()=> {
    if (!isLoadingCaseDocuments && previewFiles.length > 0) {
      setPreviewDocumentId(previewFiles[0].documentId)
    }
  }, [caseId, isLoadingCaseDocuments]);

  useEffect(() => {
    if (!caseId) {
      return
    }
    setCaseFiles([])
    fetchCaseInfo();
    fetchCaseDocuments();
    fetchCaseFiles();
    setCurrentFile({ info: {} })
    setPreviewDocumentId(null)
    setPreviewFileId(null)
    setIsLoadingCaseDocuments(true);

    const intervalId = setInterval(() => { 
      caseFiles.map((file) => {
        if (fileProcessingResultsInfo[file.id]) { 
          if (fileProcessingResultsInfo[file.id].length > 0) {
            if (fileProcessingResultsInfo[file.id].slice(-1)[0].status == 'PROCESSING')
              fetchFileProcessingResults(file.id)
          }
          else
            fetchFileProcessingResults(file.id)
        }
        else {
          fetchFileProcessingResults(file.id)
        }
      })
    }, 5000); // Poll every 5 seconds
    
    return () => {
      clearInterval(intervalId); // Clear interval on unmount
    };

  }, [caseId]); 
  

  const handleCreateAssemblyDocument = (assembly_document_id) => {
      try {
        var docInfo = { "case_id": caseId, "assembly_document_id": assembly_document_id }
        fetch(HOST + '/api/assembly_case_documents/',
        {   
          "method": "POST",
          "headers" : { 
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token'),
            'Content-Type': 'application/json'
            },  
          "body": JSON.stringify(docInfo)
         })
        .then((res) => res.json())
        .then((json) => {
          if (json['id'])
            document.location.href = '/cases/' + caseId 
       })
      } catch (err) {
        console.log(err);
      } finally {
      }
  };
  const handleSignClient = () => {
      try {
        fetch(HOST + '/api/cases/' + caseId + '/signature_requests/',
        {   
          "method": "POST",
          "headers" : { 
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
            }, 
         })
        .then((res) => res.json())
        .then((json) => {
        fetchCaseInfo()
       })
      } catch (err) {
        console.log(err);
      } finally {
      }
  };  const handleCaseTransfer = (organization_id) => {
      try {
        fetch(HOST + '/api/cases/' + caseId + '/transfer/',
        {   
          "method": "PATCH",
          "headers" : { 
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
            }, 
          "body": JSON.stringify({ "organization_id": organization_id })
         })
        .then((res) => res.json())
        .then((json) => {
          window.location = '/cases' 
       })
      } catch (err) {
        console.log(err);
      } finally {
      }
  };
  const handleCaseDestroy = () => {
      try {
        fetch(HOST + '/api/cases/' + caseId + '/',
        {   
          "method": "DELETE",
          "headers" : { 
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
            },  
         })
        .then((res) => res.json())
        .then((json) => {
          window.location = '/cases' 
       })
      } catch (err) {
        console.log(err);
      } finally {
      }
  };
  const handleCaseUpdate = (caseInfo, onSuccess) => {
      try {
        fetch(HOST + '/api/cases/' + caseId + '/',
        {   
          "method": "PATCH",
          "headers" : { 
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
            },  
          "body": JSON.stringify(caseInfo)
         })
        .then((res) => res.json())
        .then((json) => {
          onSuccess()
          setIsLoadingCaseDocuments(true);
          setCaseDocuments([]) 
          window.location.reload()})
      } catch (err) {
        console.log(err);
      } finally {
      }
  };

  const reloadCaseDocumentInfo = async () => {
    try {
      //setCurrentTypeOverride(null)
      const response = await fetch(HOST + '/api/assembly_case_documents/' + currentFile.documentId + '/', {
        "headers" : { 
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + localStorage.getItem('token')
          },  
      });
      const json = await response.json()
      setCurrentFile({ 
        type: 'case_doc', 
        documentId: json.id, 
        filename: json.name, 
        fileType: json.generate_filetype || 'json',
        created_at: json.created_at,
        info: json,
        downloadUrl: json.download_url,
      })
      //reloadCaseDocInputsProcessing(json.id) 
    }
  catch (err) {
    } 
  }

  const reloadCaseDocInputsProcessing = async (id) => {
      try {
        const response = await fetch(HOST + '/api/assembly_transformer_results?assembly_case_document_id=' + id, {
          "headers" : { 
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
            },  
        });
        const json = await response.json()
      } catch (err) {
      }   
  }

  const handleFilePreview= async (file_id) => {
      try {
        const response = await fetch(HOST + '/api/files/' + file_id, {
          "headers" : { 
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
            },  
        });
        const json = await response.json()
        const download_url = json['download_url']
        setCurrentFile({ 
          type: 'client_file',
          fileId: file_id,
          filename: json.filename,
          fileType: 'pdf',
          created_at: json.created_at,
          download_url: json.download_url || json.original_file_url,
          info: json
        })
        setPreviewFileId(file_id)
        setPreviewUrl(download_url)
        setPreviewType("pdf")
      } catch (err) {
        setError(err);
      }   
    };
  const handleCaseFileDownload= async (file_id) => {
      try {
        const response = await fetch(HOST + '/api/files/' + file_id, {
          "headers" : { 
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
          },  
        });
        const json = await response.json()
        const download_url = json['download_url']
        if (download_url){
          window.open(download_url, '_blank')
        }
      } catch (err) {
        setError(err);
      }   
    };

  const handleDelete = async (file_id) => {
      try {
        const response = await fetch(HOST + '/api/files/' + file_id +'/', { 
          "method": "DELETE",
          "headers" : { 
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
          },  
          });
        fetchCaseFiles()
        setPendingFileToDeleteId(null)
      } catch (err) {
        setError(err);
      }   
    };

  const date_s = new Date(caseInfo.created_at).toLocaleDateString()

  const fileColumns: GridColDef[] = [
    { field: 'filename', headerName: 'Filename', flex: 1 },
    { 
      field: 'type', 
      headerName: 'Type', 
      width: 150,
      valueGetter: (value, row) => row.type.split('_') 
              .map(word => word.charAt(0).toUpperCase() + word.slice(1)) 
              .join(' ')

    },
    { 
      field: 'status', 
      headerName: 'Status', 
      width: 130,
      renderCell: (params) => { 
        const logs = fileProcessingResultsInfo[params.row.id]
        if (logs) {
          const latestStatus = fileProcessingResultsInfo[params.row.id] &&  fileProcessingResultsInfo[params.row.id].length ? fileProcessingResultsInfo[params.row.id].slice(-1)[0].status : ''
          return  latestStatus == 'SUCCESS' ? (<Chip className='chip-boxy' label="Processed" color="success" />) : 
          latestStatus == 'PROCESSING' ? (<Chip label="Processing" color="primary" className='chip-boxy' />) :
          latestStatus == 'ERROR' ?
          (<Chip label="Errored" color="error" className='chip-boxy' />) : (<Chip label="Queued" color="warning" className='chip-boxy' />)
        }
        else if (params.row.type == 'retainer')
          return (<Chip label="Processed" color="success" className='chip-boxy' />)
        else
          return (<Chip label="Queued" color="primary" className='chip-boxy' />)
      }

    },
    {
      field: 'action',
      headerName: 'Actions',
      sortable: false,
      width: 100,
      renderCell: (params) =>  (
      <>
        <Tooltip title="Delete">
          <IconButton 
            size='large' 
            // onClick={() => {handleDelete(params.row.id)}}> 
            onClick={() => {setPendingFileToDeleteId(params.row.id)}}> 
            <DeleteIcon /> 
          </IconButton> 
        </Tooltip>
    </>)
    },
  ];
  
  const paginationModel = { page: 0, pageSize: 10 };

  const fileDeleteConfirmation = pendingFileToDeleteId  ? <ConfirmationDialog 
                                                        title="Confirm File Deletion"
                                                        confirmButton="Delete"
                                                        message="Are you sure you want to delete this file and any resulting processing outputs? This cannot be undone."
                                                        onCancel={ () => setPendingFileToDeleteId(null)} 
                                                        onConfirm={ () => handleDelete(pendingFileToDeleteId)} /> 
                                                    : ''
  
  const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  display:'block',
  overflow:'scroll',
  transform: 'translate(-50%, -50%)',
  width: '50%',
  height: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

  const getRowClassName = (params) => {
    return params.id === currentFile.fileId  ? 'highlighted-row' : '';
  };
  const determineProgressStep = () => {
    if (caseInfo.status == 'INITIAL' || caseInfo.status =='NEEDS_DOCUMENTATION')
      return 'Upload Files'
    else if (caseInfo.status == 'LEGAL_REVIEW')
      return 'Legal Review'
    else if (caseInfo.status == 'RETAINER_SENT')
      return 'Retainer'
  }
  
  const fetchCaseDocuments = async () => {
    try {
      const response = fetch(HOST + '/api/assembly_case_documents/?case_id=' + caseId, {
          "headers" : { 
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
            },  
      })
        .then((res) => res.json())
        .then((json) => {
          setCaseDocuments(json);
          setIsLoadingCaseDocuments(false);
       })
    } catch (err) {
      setError(err);
    } finally {
    }
  };

  const caseProgressStep = determineProgressStep()
  return (
    <>
      { processingResultModalId && 
        <PreprocessingResultDetail fileProcessingResultId={processingResultModalId} onCancel={() => setProcessingResultModalId(null) } />
      }
    {fileDeleteConfirmation} 
    <Grid container spacing={1} sx={{ height: "100%" }} > 
      <Grid item xs={5} md={6} lg={6} sx={{maxHeight: '90vh', overflow: 'auto'}} >
        <Container disableGutters={false} > 
          
          <Paper sx={{mb: 2}} elevation={0} >
            <SectionHeader title={caseInfo.name} align='center' mt={4} />
            <Box sx={{p: 2}}>
              <CaseProgress step={caseProgressStep} />
            </Box>
            {caseFiles.length == 0 && !isLoadingCaseFiles && 
              <Grid mb={4} >
                <Alert severity="info">{"Get started by adding some client documents below. We will use the files provided to help prepare this case's documents, so the more you upload the better."}</Alert>
            </Grid>
            }
            {caseFiles.length > 0 && caseProgressStep == 'Upload Client Files' &&
              <Alert severity="info">{"When you're ready to start the repair order summary document click 'Start Document' below."}</Alert>
            }
          </Paper>
        </Container>
        
        <Container disableGutters={false} > 
          <Paper>
            <CaseInfoPanel
                isLoading={isLoadingCaseInfo}
                caseInfo={caseInfo}
                handleCaseTransfer={handleCaseTransfer}
                handleCaseDestroy={handleCaseDestroy}
                handleSignClient={handleSignClient}
                handleCaseUpdate={handleCaseUpdate} /> 
          </Paper>
        </Container>
        
        <Container disableGutters={false} > 
          <Paper>
            <SectionHeader title={<div style={{paddingTop: "5px"}} >Documents</div>} mt={5} align='left' size='h5' actions={(
              <IconButton 
                size='large' 
                color='primary'
                component={Link} 
                to={"/cases/" + caseId + "/add_document"} 
                disabled={caseFiles.length == 0}>
                <AddIcon /> 
              </IconButton> 
              )} />
            <Divider />
            <Box sx={{p: 2}}>
              <CaseFacts currentFile={currentFile} setCurrentFile={setCurrentFile} caseId={caseId} context={false} /> 
            </Box>
          </Paper>
        </Container>
        <Container disableGutters={false} > 
          <Paper>
            <SectionHeader title='Facts' mt={4} align='left' size='h5' /> 
            <Divider />
          
            <Collapse in={true}>
              <Box sx={{p: 2}}>
                <CaseFacts currentFile={currentFile} setCurrentFile={setCurrentFile} showOutput={true} caseId={caseId} context={true}/>
              </Box>
            </Collapse>
          </Paper>
        </Container>
        
        <Container disableGutters={false} > 
          <Paper>
            <SectionHeader title={<div style={{paddingTop: "5px"}} >Files</div>} mt={5} align='left' size='h5' actions={(
              <IconButton 
                color='primary'
                size='large' 
                onClick={() => setShowUploadFileModal(true)} >
                <AddIcon /> 
              </IconButton> 
              )} />
            <Divider />
            <Box sx={{p: 2}}>
              { showUploadFileModal && 
                <AddFiles onUpload={(fileInfo, setSuccess, setErr) => handleCaseFileUpload(fileInfo, setSuccess, setErr)} onCancel={() => setShowUploadFileModal(false) } />
              }
              <DataGrid
                rows={caseFiles}
                columns={fileColumns}
                onRowClick={(params, event, details) => { handleFilePreview(params.row.id)} } 
                initialState={{ sorting: { sortModel: [ { field: "added_on", sort: 'desc' }]}, columns: { columnVisibilityModel: { 'pre_processing': true}}, pagination: { paginationModel } }}

              getRowClassName={getRowClassName}
                pageSizeOptions={[10, 25, 50, 100]}
                slots={{ toolbar: GridToolbar }}
                slotProps={{
                  toolbar: {
                    printOptions: { disableToolbarButton: true },
                    csvOptions: { disableToolbarButton: true },
                    showQuickFilter: true,
                  },
                }}
                disableRowSelectionOnClick
                sx={{ border: 0 }}
              />
            </Box>
          </Paper>
        </Container>
      </Grid>
      {previewFiles.length > 0 &&
        <Grid item xs={6} md={6} lg={6} sx={{height: '100%', overflow: 'auto'}} >
          <CaseDocPreviewPane 
            caseId={caseId}
            filesAreProcessing={filesAreProcessing}
            setPreviewDocumentId={setPreviewDocumentId} 
            currentFile={currentFile}
            reloadCaseDocumentInfo={reloadCaseDocumentInfo}
            setCurrentFile={setCurrentFile}
            previewDocumentId={previewDocumentId} 
            fetchDocs={() => fetchCaseDocuments()}
            previewFileId={previewFileId} 
            files={previewFiles} />
        </Grid>
      }
    </Grid>
  </>
  );
}

export default CaseView;

